module.exports = __webpack_public_path__ + "media/images/emblems/Gravesano-coat_of_arms-061e5c51b70bc4bf3ad2fda493c83819.svg";